import { render } from "./downPage.vue?vue&type=template&id=d9e1a8b4&scoped=true"
import script from "./downPage.vue?vue&type=script&lang=js"
export * from "./downPage.vue?vue&type=script&lang=js"

import "./downPage.vue?vue&type=style&index=0&id=d9e1a8b4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e1a8b4"]])

export default __exports__